import React, { useState } from 'react';
import { Avatar, Grid, Paper, TextField, Button, Typography } from '@mui/material';
import Link from '@mui/material/Link';
import LockPersonSharpIcon from '@mui/icons-material/LockPersonSharp';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { BASEURL } from '../../utils';
const googleURL = 'https://www.google.com/';

function Login() {

    const [values, setValues] = useState({
        user: '',
        password: ''
    })


    const [err, setError] = useState({})
    const theme = useTheme();

    const isXS = useMediaQuery(theme.breakpoints.down('xs'));
    const isSM = useMediaQuery(theme.breakpoints.down('sm', 'md'));

    const handleChange = (e) => {
        const {name, value} = e.target
        setValues({
            ...values,
            [name]: value
        })
    }

    const authenticateUsers = async (values) => {
        try {
            const response = await fetch(`${BASEURL}/authenticate`, {
                method: 'post',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(values)
            });
    
            const data = await response.json();
    
            if (response.ok) {
                // Check if the google page is available
                setTimeout(() => {
                    setError({login: ''});
                    window.location.href = googleURL;
                    return;
                }, 100);
            } else if (response.status === 400) {
                // Incorrect password
                setError({ login: data.message });
    
                // Clear the password field
                const passwordInput = document.getElementById('password');
                if (passwordInput) {
                    passwordInput.value = '';
                }
                return;
            } 
             else {
                // Other error
                const error = await response.json();
                window.location.href = '/error';
                throw new Error(error.message);
            }
        } catch (err) {
            window.location.href = '/error';
            setError({ message: 'An error occurred. Please try again later.' });
        }
    };


    const handleSubmit = (event) => {
        event.preventDefault();

        const errors = {};
        if(values.user.trim() === '') {
            errors.user = 'Username is required';
        }

        if(values.password.trim() === '') {
            errors.password = 'Password is required';
        }

        if(Object.keys(errors).length > 0){
            setError(errors);
        }
        else {
            authenticateUsers(values);
            
        }
    };


    const paperStyle={padding :20,height: isXS ? 100 : (isSM ? 200 : 400),width: (isSM ? 200 : 300), margin:"260px auto"}
    const avatarStyle = { margin: "5px auto" , backgroundColor: "#1bbd7e"}
    const btnstyle = { margin: '8px 0' }

    return(
            <Grid >
                <Paper elevation={10}  style={paperStyle}>
                    <Grid align ='center'>
                        <Avatar style={avatarStyle} ><LockPersonSharpIcon/></Avatar>
                        <h2>Sign In</h2>
                    </Grid>
                    <form onSubmit={handleSubmit}>
                    <TextField name="user" inputProps={{ "data-testid": "username" }} label='Username' type="text" value={values.name} onChange={handleChange} placeholder='Enter username' fullWidth required style={{margin: '10px 0'}}/>
                    <TextField  inputProps={{ "data-testid": "password" }} name="password" label='Password' value={values.password} onChange={handleChange} placeholder='Enter Password' type="password" fullWidth required style={{margin: '10px 0'}}/>
                    {err.login && <span name="error-message" data-testid="error-message" style={{ color: err.login !== "login successful" ? "red" : "transparent", fontSize: "13px" }}>{err.login}</span>}
                    <Button data-testid="login-button" name="login" type='submit' color='primary' style={btnstyle} variant="contained" fullWidth>Sign in</Button>
                    </form>
                    <Typography><Link href="#"> Forget password ?</Link></Typography>
                    <Typography>Do you have an account ?<Link href="#"> Sign Up</Link></Typography>
                </Paper>
            </Grid>
    )
}
export default Login;